import config from 'config'
import DateUtil from 'core/utilities/DateUtil'
import ErrorHandleable from '../mixins/ErrorHandleable'
import LocationUtil from 'core/utilities/LocationUtil'
import Utils from 'core/utilities/Utils.js'
import fxDateRange from 'core/components/DateRangeComponent.vue'
import fxLocation from 'core/components/LocationComponent.vue'

export default {
    beforeCreate () {
        const todayRange = DateUtil.getRange('today')
        const tomorrowRange = DateUtil.getRange('tomorrow')
        const weekendRange = DateUtil.getRange('weekend')

        this.dateRangeFilterPresets = [
            {
                key: 'today',
                label: 'Today',
                from: todayRange[0],
                to: todayRange[1]
            },
            {
                key: 'tomorrow',
                label: 'Tomorrow',
                from: tomorrowRange[0],
                to: tomorrowRange[1]
            },
            {
                key: 'weekend',
                label: 'This Weekend',
                from: weekendRange[0],
                to: weekendRange[1]
            }
        ]

        this.categories = config.categories || []

        this.whereaboutsTypes = {
            ALL: 'all',
            AWAY: 'away',
            HOME: 'home'
        }
    },
    components: {
        fxDateRange,
        fxLocation
    },
    computed: {
        serializedEndDate () {
            return this.dateRange ? DateUtil.formatForSearch(this.dateRange[1]) : null
        },
        serializedStartDate () {
            return this.dateRange ? DateUtil.formatForSearch(this.dateRange[0]) : null
        }
    },
    data () {
        return {
            category: null,
            categoryKey: null,
            dateRange: null,
            isDropDownLocationChoice: false,
            location: null,
            locationId: null,
            opponentId: null,
            segment: null,
            whereabouts: null
        }
    },
    methods: {
        onDateRangeSelected (dateRange) {
            this.$router.push({
                query: Utils.updateQueryParams(this.$route.query, {
                    date_from: dateRange ? DateUtil.formatForSearch(dateRange[0]) : null,
                    date_to: dateRange ? DateUtil.formatForSearch(dateRange[1]) : null
                })
            })
        },
        onLocationError () {
            // TODO
        },
        onOpponentIdSelected (opponentId) {
            this.$router.push({
                query: Utils.updateQueryParams(this.$route.query, { opponent_id: opponentId })
            })
        },
        onLocationIdSelected (locationId) {
            this.isDropDownLocationChoice = true
            this.$router.push({
                query: Utils.updateQueryParams(this.$route.query, { location_id: locationId })
            })
        },
        onLocationSelected (location) {
            this.$store.commit('setSelectedLocation', location)

            const query = {
                lat: null,
                lon: null
            }

            if (location && location.latitude && location.longitude && !LocationUtil.areLocationsEqual(this.location, location)) {
                query.lat = location.latitude
                query.lon = location.longitude
                query.location_id = location.id
            }

            this.pushQuery(query)
        },
        pushQuery (query) {
            this.$router.push({
                query: Utils.updateQueryParams(this.$route.query, query)
            })
        },
        replaceQuery (query) {
            this.$router.replace({
                query: Utils.updateQueryParams(this.$route.query, query)
            })
        },
        setWhereabouts (whereabouts) {
            this.pushQuery({ whereabouts })
        }
    },
    mixins: [
        ErrorHandleable
    ],
    watch: {
        categoryKey () {
            this.replaceQuery({ category: this.categoryKey || null })
        },
        $route: {
            immediate: true,
            handler (newRoute, oldRoute) {
                // TODO: We should improve this logic so that we trigger an Events fetch only if a relevant filter has changed.
                if (oldRoute && oldRoute.query.modal !== newRoute.query.modal) { return }

                const query = this.$route.query
                const hasQueryLocation = Boolean(query.lat && query.lon)
                const isFetchQueryLocation = hasQueryLocation && !LocationUtil.areLocationsEqual(this.location, {
                    latitude: query.lat ? Number(query.lat) : null,
                    longitude: query.lon ? Number(query.lon) : null
                })

                const isFetchFeaturedEvents = newRoute.name === 'home' && (!oldRoute || ['date_from', 'date_to', 'lat', 'lon'].some(queryParam => newRoute.query[queryParam] !== oldRoute.query[queryParam]))

                const isFetchNearbyPerformers = newRoute.name === 'league'

                const locationPromise = new Promise(resolve => {
                    if (isFetchQueryLocation && !this.isDropDownLocationChoice) {
                        const params = {
                            latitude: Number(query.lat),
                            longitude: Number(query.lon)
                        }
                        if (Number(query.location_id)) {
                            params.location_id = Number(query.location_id)
                        }
                        this.$marketplace
                            .getLocation(params, { timeout: 3000 })
                            .then(location => {
                                if (!location) { return }
                                this.$store.commit('setSelectedLocation', location)
                                return resolve(location)
                            })
                    } else if (hasQueryLocation) {
                        resolve(this.location)
                    } else if (config.defaultLocation) {
                        resolve(config.defaultLocation)
                    } else {
                        this.$store.state.userLocationPromise
                            .then(location => resolve(location))
                    }
                })

                let activeCategory = this.categories[0]

                if (query.category) {
                    activeCategory = this.categories.find(category => category.key === query.category) || activeCategory
                }

                if (query.date_from && query.date_to) {
                    this.dateRange = [
                        DateUtil.parse(query.date_from),
                        DateUtil.parse(query.date_to)
                    ]
                } else {
                    this.dateRange = null
                }

                if (query.location_id) {
                    this.locationId = Number(query.location_id)
                }

                if (query.opponent_id) {
                    this.opponentId = Number(query.opponent_id)
                }

                if (query.whereabouts === this.whereaboutsTypes.AWAY) {
                    this.whereabouts = this.whereaboutsTypes.AWAY
                } else if (query.whereabouts === this.whereaboutsTypes.HOME) {
                    this.whereabouts = this.whereaboutsTypes.HOME
                } else {
                    this.whereabouts = this.whereaboutsTypes.ALL
                }

                this.segment = query.segment || null

                this.searchQuery = this.$route.query.q
                this.category = activeCategory
                this.categoryKey = (this.category || {}).key || null

                if (!this.isFetchNearbyEvents) {
                    this.events = []
                    this.page = 1
                }

                locationPromise
                    .then(location => {
                        this.location = location

                        if (this.isFetchNearbyEvents) {
                            this.hasNearbyLocationChanged = false
                            this.loadLocalEvents()
                        } else {
                            this.loadEvents()
                        }

                        if (isFetchNearbyPerformers) {
                            this.fetchLocalPerformers()
                        }

                        if (isFetchFeaturedEvents) {
                            if (config.hasExclusiveFeaturedEventsView) {
                                this.fetchExclusiveFeaturedEvents()
                            } else {
                                this.fetchFeaturedEvents()
                            }
                        }
                    })
                    .catch(err => this.catchAndLog(err))
            }
        }
    }
}
